import React from "react"
import { twMerge } from "tailwind-merge"
import { ChevronUpIcon } from "@heroicons/react/20/solid"
import scrollTo from "gatsby-plugin-smoothscroll"

const BackToTop = () => {
  return (
    <div id="backtotop" className="z-50 -mt-12 flex bg-transparent">
      <div
        className={twMerge([
          "group",
          "mx-auto mb-4 flex flex-col items-center justify-center text-center text-slate-500 transition hover:text-slate-600",
        ])}
      >
        <ChevronUpIcon className="h-3 w-3 animate-bounce stroke-current" />
        <button
          className="text-xs font-extralight"
          onClick={() => scrollTo("#top")}
        >
          back to top
        </button>
      </div>
    </div>
  )
}

export default BackToTop
